import { Badge } from "@radix-ui/themes"

export default function InputError({ message }: { message?: string }) {
  return message ? (
    <Badge variant="soft" color="ruby">
      {message}
    </Badge>
  ) : null
}
